import React from "react";
import "./PravnoLiceCard.scss";
import "../pages/LoginPravnogLicaUspio.scss";
import { useFormik } from "formik";
import * as Yup from "yup";
import Button from "./Button";
import { Link } from "react-router-dom";

function NoviZahtjeviZaUslugamaCard({ datum, ime, kontakt, poruka, id }) {
  const formik = useFormik({
    initialValues: {
      porukaInput: "",
    },
    validationSchema: Yup.object({
      porukaInput: Yup.string().required("Niste unijeli poruku."),
    }),

    onSubmit: (values) => {
      console.log(values);
    },
  });

  return (
    <form id="login-pravnog-lica-uspio" onSubmit={formik.handleSubmit}>
      <ul>
        <li>{datum}</li>
        <li>{ime}</li>
        <li>{kontakt}</li>
      </ul>
      <label htmlFor="porukaInput">Poruka</label>
      <textarea
        id="porukaInput"
        name="porukaInput"
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={poruka}
        readOnly={true}
      />
      <Link to={`/kontakt-pravnog-lica/${id}`}>
        <Button type="submit" value="ODGOVORI"></Button>
      </Link>
    </form>
  );
}

export default NoviZahtjeviZaUslugamaCard;
